import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MapsSidebarService } from './maps-sidebar.service';
import {
  SideBarComponent,
  PropertyFilterComponent,
  RetailerFilterComponent,
  DemographicFilterComponent,
  HiddenFilterComponent,
  OverlayFilterComponent,
  MeasureFilterComponent,
  PlaceFilterComponent,
} from './components/index';

// 3rd party
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    PerfectScrollbarModule,
  ],
  declarations: [
    SideBarComponent,
    PropertyFilterComponent,
    RetailerFilterComponent,
    DemographicFilterComponent,
    HiddenFilterComponent,
    OverlayFilterComponent,
    MeasureFilterComponent,
    PlaceFilterComponent,
  ],
  providers: [
    MapsSidebarService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  exports: [SideBarComponent]
})
export class MapsSidebarModule { }



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/maps-sidebar.module.ts